// Renamed from LandingPageAI.js
import React from 'react';
import LandingPageAI from './LandingPageAI';

const SmartSleepPlan = () => {
  return <LandingPageAI />;
};

export default SmartSleepPlan;
